var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTableView)?_c('TableView',{attrs:{"col":_vm.columns,"getData":_vm.getData,"Options":{tblClass:'eachThree table-striped table-bordered'}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }